$(document).on('click','.vari-tab-btn',function(){
  $(this).parent().find('.variant-content-drawer').attr('open','open');
  $('html').addClass('lock-all');
  if($(window).width() < 989){
    $(this).parent().find('.vari-drawer__overlay.mobile-overlay').addClass('show-overlay');
  }
});

$(document).on('click','.vari-drawer__overlay, .vari-drawer-close-btn',function(){
  $(this).closest('.variant-tab-info').find('.variant-content-drawer').removeAttr('open');
  $('html').removeClass('lock-all');
  $('.vari-drawer__overlay.mobile-overlay').removeClass('show-overlay');
});


$(document).on('click','.option-value-item',function(){
  var dataOption = $(this).attr('data-option');
  
  $(this).closest('.option-value-info').find('.option-value-item').removeClass('is--selected');
  $(this).addClass('is--selected');
  $('.swatch-list-info input[data-option="'+dataOption+'"]').trigger('click');

  var dataValue = $(this).attr('data-val');
  $(this).closest('.variant-tab-info').find('.vari-title').html(dataValue);

  var dataSrc = $(this).attr('data-src');
  $(this).closest('.variant-tab-info').find('.vari-tab-btn .vari-img').attr('src',dataSrc);
  
  $('.vari-drawer__overlay.mobile-overlay').removeClass('show-overlay');
  $(this).closest('.variant-tab-info').find('.variant-content-drawer').removeAttr('open');
  $('html').removeClass('lock-all');
});